/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { feedItemV2Schema } from '../getFeedV2/get-feed-v2-response';

export const getFeedV3ResponseDataSchema = z.array(feedItemV2Schema);

export type IGetFeedV3ResponseData = z.infer<typeof getFeedV3ResponseDataSchema>;

export const getFeedV3ResponseSchema = createApiResponseSchema(
  getFeedV3ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetFeedV3ResponseData>>;

export type IGetFeedV3Response = IAPI<IGetFeedV3ResponseData>;
